import SidebarItem from '../../sidebarItem/SidebarItem';
import { useLocation } from 'react-router-dom';
import { useWorkspaceHook } from 'utils/CustomHooks/useWorkspaceHook';
import AnnouncementsIcon from 'components/Icons/sidebarIcons/announcementsIcon';
interface PropTypes {
  sidebarOpen: boolean;
}

const SidebarAnnouncements = (props: PropTypes) => {
  const location = useLocation();
  const { navigateWithWorkspaceUrl } = useWorkspaceHook();
  const currentPath = `${location?.pathname}${location?.search}`;
  const { sidebarOpen } = props;

  const isSelected = currentPath.includes('/announcements');

  return (
    <SidebarItem
      title={'Announcements'}
      icon={<AnnouncementsIcon filled={isSelected} />}
      onClick={() => navigateWithWorkspaceUrl('/announcements?view=viewer')}
      isSelected={isSelected}
      sidebarOpen={sidebarOpen}
    />
  );
};

export default SidebarAnnouncements;
